<script setup>
import { ref, watch } from 'vue';
import CheckboxInput from '../../../vue-elements/input/CheckboxInput.vue';
import CheckboxList from '../../../vue-elements/input/CheckBoxList.vue';
import FieldLabel from '../../../vue-elements/field/FieldLabel.vue';
import FieldError from '../../../vue-elements/field/FieldError.vue';
import TextAreaInput from '../../../vue-elements/input/TextareaInput.vue';
import { logAnalyticsEvent } from '../../../../assets/js/helpers/bananas';
import { useOrderStore } from '../stores/orderStore';
import bolImage from '/web/assets/general/bol-cadeaukaart.png';
import { useEnergyComparisonStore } from '../stores/energyComparison';

const orderStore = useOrderStore();
const comparisonStore = useEnergyComparisonStore();
const orderData = ref({
    order: orderStore.submitOrder,
    customer_gender: orderStore.customer_gender,
    customer_name: orderStore.customer_first_name + ' ' + orderStore.customer_last_name,
    customer_email: orderStore.customer_email,
    current_provider: orderStore.current_provider,
    customer_phone: orderStore.customer_phone,
});

// Step 1 (Submit feedback)
const feedbackSubmitted = ref(false);

const feedback = ref({ options: [], other: '', details: '' });

const feedbackError = ref('');

const feedbackOptions = [
    { value: 'missende-info', label: 'Ik had niet alle informatie' },
    { value: 'lastig-beslissen', label: 'Lastig om keuze te maken' },
    { value: 'prijsopbouw-onduidelijk', label: 'Prijsopbouw of tarieven onduidelijk' },
    { value: 'aanmeldeformulier-onduidelijk', label: 'Aanmelden was niet duidelijk' },
];


if (!orderStore.moving_in) {
    feedbackOptions.splice(2, 0, { value: 'ingangsdatum-onduidelijk', label: 'Einddatum bestaand contract onbekend' });
}

if (comparisonStore.filters.electricityGenerated && comparisonStore.filters.electricityGeneration > 0) {
    feedbackOptions.splice(2, 0, { value: 'terugleverkosten-onduidelijk', label: 'Terugleverkosten niet duidelijk' });
}

const submitFeeddback = () => {
    if (feedback.value.options.length === 0) {
        feedbackError.value = 'Kies minimaal één optie';
        return;

    } else if (feedback.value.options.includes('iets-anders') && feedback.value.other === '') {
        feedbackError.value = 'Vul een toelichting in a.u.b.';
        return;
    } else {
        logAnalyticsEvent('compare-energy.feedback.submit', {
            feedback: feedback.value.options,
            other: feedback.value.other,
            details: feedback.value.details,
            orderData: orderData.value,
        });
        feedbackSubmitted.value = true;
    }
}


// // Step 2 (Allow phonecall)
// const phoneCallSubmitted = ref(false);

// const phonecall = ref({ phone: orderStore.customer_phone });

// const submitPhoneCall = () => {
//     logAnalyticsEvent('compare-energy.feedback.allowPhonecall', {
//         orderData: orderData.value,

//     });
//     phoneCallSubmitted.value = true;
// }

// watch(() => feedback.value.options, () => {
//     feedbackError.value = '';
// });


// Alternative step 2, more feedback

const detailsSubmitted = ref(false);

const submitDetails = () => {
    logAnalyticsEvent('compare-energy.feedback.submitDetails', {
        feedback: feedback.value.options,
        other: feedback.value.other,
        details: feedback.value.details,
        orderData: orderData.value,
    });
    detailsSubmitted.value = true;
}
</script>


<template>
    <div class="order-feedback" v-auto-animate>
        <template v-if="!feedbackSubmitted && !detailsSubmitted">
            <h3>Jij maakt onze vergelijker beter!</h3>
            <p>
                Laat ons weten wat er beter kan en help ons om onze vergelijker te verbeteren.
            </p>
            <div class="feedback-question question">
                <div class=" feedback-question ">
                    <FieldLabel class=" long-label" label="Waar liep je tegenaan?">
                    </FieldLabel>
                    <div class="first-field">

                        <CheckboxInput id="feedback" v-model="feedback.options" value="geen-problemen">
                            Nergens</CheckboxInput>
                    </div>
                    <div :class="{ grayscale: feedback.options.includes('geen-problemen') }">

                        <CheckboxList v-model="feedback.options" :options="feedbackOptions" />

                        <div style="margin-top:20px;">
                            <CheckboxInput id="iets-anders" v-model="feedback.options" value="iets-anders">
                                Anders, namelijk:</CheckboxInput>

                            <TextAreaInput v-if="feedback.options.includes('iets-anders')" id="iets-anders"
                                v-model="feedback.other" placeholder="Vul hier in">
                            </TextAreaInput>
                        </div>
                    </div>
                    <FieldError :error="feedbackError"></FieldError>

                    <FieldLabel label="* meerdere opties mogelijk" class="field-label subtle"></FieldLabel>
                    <div class="feedback-question button">
                        <button class="btn primary" @click="submitFeeddback">Verstuur</button>
                    </div>
                </div>
            </div>
        </template>
        <!--
            <template v-else-if="feedbackSubmitted && !phoneCallSubmitted">
                <div class="feedback-question question">
                    <h3>Mogen we je bellen? </h3>
                         
                    <p>
                        We willen je graag kort (max. 5 minuten) bellen om je overstapervaring te bespreken.
                    </p>
                    <p> Als dank krijg je
                        van ons een
                        <strong>Bol.com cadeaukaart t.w.v. 10 euro</strong>.
                    </p>
                    
                </div>
                <div class="feedback-question button">
                    <button class="btn primary" @click="submitPhoneCall">Ja, dat is goed!</button>
                </div>
            </template>
        -->

        <template
            v-else-if="feedbackSubmitted && !detailsSubmitted && !feedback.other && !feedback.options.includes('geen-problemen')">
            <div class="feedback-question question">
                <h3>Wat kon er beter?</h3>
                <p>
                    Je hebt aangegeven tegen het volgende aangelopen te zijn:
                    <template v-for="(option, index) in feedback.options">
                        <span v-if="index > 0">, </span>
                        <strong>{{ feedbackOptions.find(opt => opt.value === option).label }}</strong>
                    </template>
                </p>
                <p> Zou je hier wat meer toelichting op willen geven?</p>

                <TextAreaInput v-model="feedback.details" placeholder="Vul hier in"></TextAreaInput>

            </div>
            <div class="feedback-question button">
                <button class="btn primary" @click="submitDetails">Stuur feedback</button>
            </div>
        </template>
        <template v-else>
            <h3>Bedankt voor je feedback!</h3>
            <p>Met jouw hulp maken we energie vergelijken voor iedereen nog makkelijker!</p>

        </template>
    </div>
</template>



<style lang="scss">
@use 'assets/scss/all.scss' as *;

.order-feedback {
    border: 2px solid $border-base;
    background-color: $background-default;
    padding: 16px;
    border-radius: 16px;

    h3 {
        margin-bottom: 12px;
    }

    p {
        font-size: 16px;
    }

    .field-label {
        margin-top: 12px;
        line-height: 22px;

        &.subtle {
            color: $text-subtle;
        }
    }

    .long-label {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }

    .grayscale {
        filter: grayscale(100%);
        pointer-events: none;
    }

    .feedback-question {

        &.question {
            margin-bottom: 20px;
        }

        &.button {
            display: flex;


        }
    }

    .first-field {
        margin-bottom: 20px;
    }

    .checkbox-list {
        margin-bottom: 0;

    }

    .checkbox-input-field {
        &:not(:last-child) {
            margin-bottom: 12px;
        }

        input {
            min-width: 16px;
            width: 16px;
            height: 16px;
            align-self: flex-start;
            margin-top: 4px;
        }

        label {
            font-size: 16px;
            line-height: 20px;
            font-weight: 500;
        }
    }

    .text-input-container {
        display: inline-block;
    }
}
</style>